// @flow
import "./contextPath";

import createUUID from "../utils/helpers/createUUID";
import { getFullRequestHref } from "./requestInformation";

import {
  createReduxStore,
  setI18n,
  setApplication,
  setServerPreferences,
  setConfigurationTheme,
  handleErrors,
} from "./serverUtil";

import { handleBeforeRenderHooks } from "../redux/store/beforeRenderHooks";

import renderSSRMinimal from "./renderSSRMinimal";

import createTheme from "../react-theme/createTheme";

import type { TemplateProps } from "./htmlpage";
import type { BeforeRenderHook } from "../redux/store/beforeRenderHooks";
import type { PreferenceValue } from "./serverUtil";
import type { LocaleConfiguration } from "../i18n/types";
import type { Theme } from "../react-theme/types";

type serverProps = {
  request: HttpServletRequestJava,
  locales?: Array<LocaleConfiguration>,
  customReducers?: Object,
  theme?: Theme | Array<Theme>,
  serverPreferences?: Array<string | PreferenceValue>,
  render: Function,
  template?: (TemplateProps) => string,
  beforeRenderHooks?: Array<BeforeRenderHook>,
  preloadApplication?: boolean,
};

/**
 */
const serverNoSSR = ({
  request,
  locales,
  customReducers,
  serverPreferences = [],
  theme,
  render,
  template,
  beforeRenderHooks,
  preloadApplication = true,
}: serverProps): string => {
  const isPreviewCheck = request.getHeader("X-BI-Preview-Available");
  if (isPreviewCheck) {
    return "<h1>Preview Available</h1>";
  }

  const UUID = createUUID();
  __webpack_nonce__ = UUID; // NOSONAR

  const requestHref = getFullRequestHref(request);

  const store = createReduxStore(requestHref, customReducers);

  setServerPreferences(store, serverPreferences);
  setConfigurationTheme(store);

  if (theme) {
    const storedTheme = store.getState()?.preferences?.theme;
    //$FlowFixMe[incompatible-call]
    createTheme(storedTheme, theme);
  }

  setI18n(store, locales, request);

  if (preloadApplication) {
    setApplication(store);
  }

  handleErrors(store);

  handleBeforeRenderHooks(beforeRenderHooks, { store, request });

  return renderSSRMinimal({ store, theme, UUID, render, template });
};

export default serverNoSSR;
